module.exports = __webpack_public_path__ + "static/media/Contact Us Circle.2da5a822.svg";